export default __webpack_public_path__ + "static/media/hatching-icon-positive.d6e47952.svg";